import React from 'react';
import { Button } from '@/components/ui/button';
import { X, RefreshCw } from 'lucide-react';

const UpdateNotification = ({ onRefresh, onDismiss }) => {
  return (
    <div className="fixed top-0 left-0 right-0 z-50 bg-blue-600 text-white shadow-lg">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <RefreshCw className="h-5 w-5 flex-shrink-0" />
          <p className="text-sm font-medium">
            New version available! Refresh to get the latest updates.
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Button
            onClick={onRefresh}
            size="sm"
            className="bg-white text-blue-600 hover:bg-blue-50 font-medium"
          >
            Refresh
          </Button>
          <button
            onClick={onDismiss}
            className="p-1 hover:bg-blue-700 rounded transition-colors"
            aria-label="Dismiss"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateNotification;
